export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_07.0d0bd582.jpg";